/**
 * @desc PDA检测更新
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PdaVersionUpdateResponseDto>;
export function request(
  params: API.basics.pdaVersion.checkUpdate.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/pda/checkUpdate`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
